module.exports = __webpack_public_path__ + "static/movie_alt-086e7345699a0c66e402cfa540f707ec.png";